import API from "shared/services/Api";
import {
  ISchedule,
  IScheduleInit,
  IScheduleInitResponse,
  IScheduleResponse,
  IScheduleRestart,
  IScheduleRestartResponse,
  IScheduleDetailResponse,
} from "shared/types/Schedule";

export const getSchedule = async (
  data: ISchedule
): Promise<IScheduleResponse> =>
  API.get(`oc/schedules?id=${data.id}&date=${data.date}`);

export const getScheduleDetail = async (
  idSchedule: number,
  userId: string
): Promise<IScheduleDetailResponse> =>
  API.get(`oc/schedules/${idSchedule}/detail?id=${userId}`);

export const scheduleInit = async (
  data: IScheduleInit
): Promise<IScheduleInitResponse> => API.post("oc/service/init", data);

export const scheduleRestart = async (
  data: IScheduleRestart
): Promise<IScheduleRestartResponse> => API.post("oc/service/restart", data);
